module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "search-input"
    }
  }, [_c('button', {
    class: _vm.buttontext ? '' : 'icon',
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('search')
      }
    }
  }, [_vm._v(_vm._s(_vm.buttontext) + " "), (!_vm.buttontext) ? _c('i', {
    staticClass: "fa fa-search"
  }) : _vm._e()]), _vm._v(" "), _c('input', {
    attrs: {
      "aria-label": "Search",
      "type": "search",
      "placeholder": _vm.placeholder
    },
    on: {
      "focus": function($event) {
        return _vm.$emit('focus')
      },
      "input": _vm.handleInput,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.$emit('search')
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-af49876c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchInput.vue
// module id = 467
// module chunks = 2